import { LessonPlanOrder } from '@/data/services/lessonPlanServices';
import LessonPlan from '@/models/LessonPlan';
import LessonPlanItem from '@/models/LessonPlanItem';

export const adapterLessonPlanOrder = (
  parents: LessonPlan[],
  childrenMap: Record<string, LessonPlanItem[]>,
): LessonPlanOrder[] =>
  parents.map(lessonPlan => ({
    id: lessonPlan.id,
    itemsIds: (childrenMap[String(lessonPlan.id)] ?? []).map(item => ({
      id: item.id,
    })),
  }));
